import { ReactElement, useState } from 'react';

import FilterListIcon from '@mui/icons-material/FilterList';
import MUIButton from '@mui/material/Button';

import CustomDropdown from '../CustomDropdown';

import ClearFilterButton from './components/ClearFilterButton';
import CustomMenuFooter from './components/CustomMenuFooter';
import CustomMenuHeader from './components/CustomMenuHeader';

type FilterDropdownProps = {
    filters?: ReactElement[];
    handleOnClearFilters?: () => void;
    handleOnApplyFilters?: () => void;
    isFilterActive?: boolean;
};

export default function FilterDropdown({
    filters = [],
    handleOnClearFilters,
    handleOnApplyFilters,
    isFilterActive,
}: Readonly<FilterDropdownProps>) {
    const [activeFilters, setActiveFilters] = useState(isFilterActive || false);

    const filterTriggerStyle = {
        borderWidth: '2px',
        borderRadius: '8px',
        borderColor: activeFilters ? undefined : '#E5E5E5',
        color: activeFilters ? undefined : '#444444',
    };

    const handleClearFilters = () => {
        setActiveFilters(false);
        handleOnClearFilters?.();
    };

    const handleApplyFilters = () => {
        setActiveFilters(isFilterActive);
        handleOnApplyFilters?.();
    };

    const filterTriggerButton = (
        <MUIButton
            style={filterTriggerStyle}
            data-testid="filter-dropdown-button"
            startIcon={<FilterListIcon />}
            variant="outlined"
        >
            Filter
            <ClearFilterButton active={activeFilters} onClear={handleClearFilters} />
        </MUIButton>
    );

    return (
        <CustomDropdown
            keepOpen
            trigger={filterTriggerButton}
            minWidth={300}
            menu={[
                <CustomMenuHeader key="filters-header" />,
                ...filters,
                <CustomMenuFooter
                    key="filters-footer"
                    onClearAll={handleClearFilters}
                    onApply={handleApplyFilters}
                />,
            ]}
        />
    );
}
